// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

$(document).ready(function() {
    $('.download .wp-block-button__link').on('click', function(e) {
        e.preventDefault()
        $(this).parent('.download').css('display', 'none')
        const targetForm = $(this).parents('.wp-block-column').find('form')
        $(targetForm).parents('.display-none').removeClass('display-none')
        const fileUrl = this.href

        $(targetForm).on('wpcf7mailsent', function() {
            window.open(fileUrl, '_blank')
        })
    })
})